<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/">Экспертиза промышленной безопасности</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expprombez">Проведение экспертизы промышленной безопасности (ЭПБ)</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expprombez/expertpd">Экспертиза промышленной безопасности проектной документации</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Экспертиза промышленной безопасности проектной документации
    </h1>
    <ul class="link-arrow">
      <li><svg width="12" height="12" viewBox="0 0 12 12" style="width: 10px;" fill="none"
               xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="0.34314" width="8" height="8" transform="rotate(45 6 0.34314)" fill="#494949"/>
      </svg>&nbsp; 20 лет опыта&nbsp;</li>
      <li><svg width="12" height="12" viewBox="0 0 12 12" style="width: 10px;" fill="none"
               xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="0.34314" width="8" height="8" transform="rotate(45 6 0.34314)" fill="#494949"/>
      </svg>&nbsp; Надежный договор, фиксирующий все наши обязательства</li>
      <li><svg width="12" height="12" viewBox="0 0 12 12" style="width: 10px;" fill="none"
               xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="0.34314" width="8" height="8" transform="rotate(45 6 0.34314)" fill="#494949"/>
      </svg>&nbsp; Оперативное проведение экспертизы</li>
      <li><svg width="12" height="12" viewBox="0 0 12 12" style="width: 10px;" fill="none"
               xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="0.34314" width="8" height="8" transform="rotate(45 6 0.34314)" fill="#494949"/>
      </svg>&nbsp; Поэтапная оплата услуг</li><li><svg width="12" height="12" viewBox="0 0 12 12" style="width: 10px;" fill="none"
               xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="0.34314" width="8" height="8" transform="rotate(45 6 0.34314)" fill="#494949"/>
      </svg>&nbsp; Консультация от ведущих специалистов рынка</li>
    </ul>
    <app-recall-form heading="Заказать экспертизу промышленной безопасности"></app-recall-form>
    <p>В отношении документации на техническое перевооружение, консервацию и ликвидацию опасного производственного объекта&nbsp;&ndash; в соответствии с ФЗ№116 от 21.07.1997 проводится экспертиза промышленной безопасности проекта, экспертиза рабочей документации.</p>

    <h2>Экспертиза промбезопасности проектов проводится:</h2>

    <ul class="marked ml-50">
      <li>до начала работ по техническому&nbsp;перевооружению, консервации и ликвидации опасного производственного объекта;</li>
      <li>после внесения изменений в разделы проектной документации на техническое перевооружение, консервацию и ликвидацию опасного производственного объекта.</li>
    </ul>

    <p><em>Экспертиза проектной документации проводится экспертной организацией, имеющей лицензию Ростехнадзора на право проведения указанной экспертизы.</em></p>

    <p><strong>ООО &quot;Протос Экспертиза&quot; имеет право на проведение экспертизы&nbsp;промышленной безопасности проектов консервации и ликвидации, а также технического перевооружения на основании оформленной лицензии.</strong></p>

    <p><strong>В комплекс&nbsp;работ входит как проведение&nbsp;самой экспертизы, так и оказание комплексного&nbsp;сопровождения&nbsp;регистрации экспертизы в Ростехнадзоре.&nbsp;В&nbsp;результате вы получите заключение о промышленной безопасности и уведомление о внесении&nbsp;экспертизы в реестр&nbsp;Ростехнадзора.</strong></p>
    <div class="mt-5 row">
      <div class="col">
        <img src="assets/img_28.png" height="880" alt="" style="width: 100%">
        <p class="text-center">Наша лицензия на ЭПБ</p>
      </div>
      <div class="col">
        <img src="assets/uved.jpg" height="880" style="width: 100%;" alt="">
        <p class="text-center">Пример уведомления</p>

      </div>
    </div>
    <app-atomka-calc heading="Получить консультацию по вопросам экспертизы промышленной безопасности проектной документации и последующий расчет стоимости"></app-atomka-calc>
    <h2>Почему для проведения экспертизы проектной документации (КЛ, ТП)&nbsp;стоит выбрать именно нас?</h2>

    <ul class="marked ml-50">
      <li>Более 20 лет мы успешно проводим ЭПБ проектов и соответствуем всем требованиям РФ.</li>
      <li>Консультации по всем вопросам, касающимся экспертизы.</li>
      <li>Возможность поэтапной оплаты услуг.</li>
      <li>Прозрачный договор с четко оговоренными сроками и результатом.</li>
      <li>Наши эксперты&nbsp;подтвердили&nbsp;свои знания и успешно сдали&nbsp;аттестацию в Ростехнадзоре.</li>
    </ul>

    <p>Стоимость зависит от класса опасности ОПО, от объема выполняемых работ и рассчитывается индивидуально. Для получения окончательного расчета оставьте запрос или контакты для связи с Вами.</p>
    <app-recall-form heading="Получить консультацию менеджера"></app-recall-form>

    <h2>Для проведения экспертизы потребуются следующие документы:</h2>

    <ul class="marked ml-50">
      <li>проектная документация на консервацию, ликвидацию и техническое перевооружение объекта, в некоторых случаях достаточно отдельных разделов проекта;</li>
      <li>выписка из реестра СРО (проектной организации);</li>
      <li>копии протоколов по аттестации по промышленной безопасности (проектировщика и ГИПа).</li>
    </ul>

    <p>При экспертизе проектной документации могут анализироваться части проекта или весь проект в целом. Сроки проведения зависят от объемов работы и определяются индивидуально.</p>

    <h2>В ходе экспертизы промышленной безопасности проектной документации&nbsp;проводятся анализ и оценка:</h2>

    <ol class="marked">
      <li>оптимальности принятого технологического процесса в части его безопасности и надежности, обоснованности технических решений и мероприятий по обеспечению безопасности ведения работ, предупреждению аварийных ситуаций и ликвидации их последствий;</li>
      <li>характеристик основных взрывопожароопасных, токсичных свойств сырья, полупродуктов, товарного продукта и отходов;</li>
      <li>наличия и достаточности мероприятий, направленных на обеспечение безопасности проектируемого объекта;</li>
      <li>возможности оперативного и безопасного отключения отдельных элементов или участков объекта для производства ремонтных и аварийных работ;</li>
      <li>оптимальности применяемых в проекте решений по компоновке технологического оборудования;</li>
      <li>безопасности и рациональности проектных решений по размещению зданий и сооружений;</li>
      <li>применения новых технологий и материалов при проектировании опасного производственного объекта в соответствующей отрасли промышленности;</li>
      <li>сравнения предлагаемого метода производства с другими известными методами в зарубежной практике;</li>
      <li>автоматизированных систем управления технологическими процессами и систем оперативного управления, прогнозирования, обнаружения, предупреждения и ликвидации аварийных ситуаций;</li>
      <li>условий обеспечения взрывобезопасности зданий и их вентиляции, возможности автоматического поддержания заданных параметров эксплуатации, управления, эффективности систем противоаварийной защиты и сигнализации;</li>
      <li>эффективности систем резервирования для обеспечения бесперебойности технологических процессов в случае отключения систем энергоснабжения;</li>
      <li>мероприятий по обеспечению контроля герметичности и выполнения требований по защите оборудования от коррозии, выполнения условий надежности;</li>
      <li>выполнения требований взрывопожаробезопасности, предъявляемых к зданиям и сооружениям в зависимости от технологического назначения, системам приточно-вытяжной вентиляции, к контролю загазованности;</li>
      <li>соответствия категории надежности энергоснабжения, уровня оснащенности контрольно-измерительными приборами и средствами противоаварийной защиты нормативным требованиям;</li>
      <li>оптимальности выбора основного и вспомогательного оборудования, его компоновки и схем обвязки, оснащения запорной, регулирующей арматурой, предохранительными устройствами и системами автоматического управления, регулирования, защиты, сигнализации, контроля и учета, уровня взрывозащищенности электрооборудования;</li>
      <li>обеспечения безопасности эксплуатационного персонала, достаточности мер по локализации и ликвидации последствий аварий.</li>
    </ol>

    <p>Если заключение экспертизы отрицательное, то проектная документация направляется на доработку, а после внесения дополнений и изменений документация отправляется на повторную экспертизу.</p>

    <p><em>Стоимость проведения экспертизы промышленной безопасности проектной документации зависит от многих факторов, поэтому рекомендуем вам обращаться к нашим экспертам или оставить заявку и мы с вами свяжемся.</em></p>

    <app-reviews-block class="w-100"></app-reviews-block>
  </div>
</div><app-footer></app-footer>
